import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NotificationsModule } from "src/app/shared/notifications/notifications.module";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { TranslateModule } from "@ngx-translate/core";
import { MessageModule } from "primeng/message";
import { TableModule } from "primeng/table";
import { TooltipModule } from "primeng/tooltip";
import { InputMaskModule } from "primeng/inputmask";
import { SfDropDownModule } from "src/app/shared/components/dropdown/dropdown.module";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DropdownModule } from "primeng/dropdown";
import { ColorPickerModule } from "primeng/colorpicker";
import { LoaderModule } from "src/app/shared/components/loader/loader.module";
import { ListboxModule } from "primeng/listbox";
import { DataViewModule } from 'primeng/dataview';
import { CheckboxModule } from 'primeng/checkbox';
import { ScArchiveTypeGridComponent } from "./pages/sc-archive-type-grid/sc-archive-type-grid.component";
import { ScArchiveTypeListMultiComponent } from "./pages/sc-archive-type-list-multi/sc-archive-type-list-multi.component";
import { ScArchiveTypeRoutingModule } from "./sc-archive-type.routing.module";
import { ScArchiveTypeService } from "src/app/core/services/sc-archive-type/sc-archive-type.service";

@NgModule({
    declarations: [ScArchiveTypeGridComponent, ScArchiveTypeListMultiComponent],
    exports: [ScArchiveTypeGridComponent, ScArchiveTypeListMultiComponent],
    imports: [
        CommonModule,
        ScArchiveTypeRoutingModule,
        FormsModule,
        NotificationsModule,
        ButtonModule,
        InputTextModule,
        TranslateModule,
        MessageModule,
        TableModule,
        TooltipModule,
        InputMaskModule,
        SfDropDownModule,
        DialogModule,
        ConfirmDialogModule,
        DropdownModule,
        ColorPickerModule,
        LoaderModule,
        ListboxModule,
        DataViewModule,
        CheckboxModule
    ],
    providers: [ScArchiveTypeService]
})
export class ScArchiveTypeModule {}
